import { useEffect } from 'react'

import { ProgressBarOrgFit } from '@/components/progressBar'
import { ScrollToTop } from '@/components/scrollToTop'

import { pagesOrder } from './config/pages/pageOrder'
import { pagesConfig } from './config/pages/selectionPages'
import { OrgfitRoutes } from './orgfitRoutes'
import faviconIcon from './public/favicons/orgfit/favicon.png'

import './css/index.css'

const currentLanguage = window.config.DEFAULT_LOCALE || 'en'
const className = 'of-op-3-ltp ' + currentLanguage

export const Orgfit = () => {
  useEffect(() => {
    const favicon = document.getElementById('favicon')
    if (favicon && favicon instanceof HTMLLinkElement) {
      favicon.href = faviconIcon
    }
  }, [])

  return (
    <>
      <ScrollToTop />
      <div id="app-sub-root">
        <div id="content" className={className}>
          <ProgressBarOrgFit pagesConfig={pagesConfig} pageOrder={pagesOrder} />
          <OrgfitRoutes />
        </div>
      </div>
    </>
  )
}
